import {apiClient} from "@/state/modules/apiClient";
const controller = "AppleIDConnector";
export const actions = {
    async getPagingParams({commit}, params) {
        return apiClient.post(controller + "/get-paging-params", params);
    },
    async create({commit}, values) {
        return apiClient.post(controller + "/create", values);
    },
    async processAppleId({commit, dispatch}, values) {
        return apiClient.put(controller + "/process-apple-id", values);
    },
    async delete({commit}, id) {
        return await apiClient.delete(controller + "/delete/" + id);
    },
};
